export const MAX_LENGTH = 190;
export const INPUT_MAX_LENGTH = 20;

interface BaseWordStudyFieldProps {
  key: string;
  label: string;
  id: (uniqueId: string) => string;
  placeholder: string;
  qa: string;
  maxLength?: number;
}

interface WordComponentFieldProps extends BaseWordStudyFieldProps {
  meaning: {
    key: string;
    label: string;
    maxLength?: number;
    id: (uniqueId: string) => string;
    placeholder: string;
    qa: string;
  };
}

interface WordDefinitionFieldProps extends BaseWordStudyFieldProps {
  meaning?: never;
}

export const WORD_COMPONENT_FIELDS: WordComponentFieldProps[] = [
  {
    key: "prefix",
    label: "Prefix",
    id: (uniqueId: string) => `prefix-${uniqueId}`,
    placeholder: "None",
    qa: "prefix",
    maxLength: INPUT_MAX_LENGTH,
    meaning: {
      key: "prefix_meaning",
      label: "Prefix meaning",
      id: (uniqueId: string) => `prefix-meaning-${uniqueId}`,
      placeholder: "Meaning of prefix",
      qa: "prefix-meaning",
      maxLength: INPUT_MAX_LENGTH,
    },
  },
  {
    key: "root_word",
    label: "Root Word",
    id: (uniqueId: string) => `root-word-${uniqueId}`,
    placeholder: "None",
    qa: "root-word",
    maxLength: INPUT_MAX_LENGTH,
    meaning: {
      key: "root_word_meaning",
      label: "Root word meaning",
      id: (uniqueId: string) => `root-word-meaning-${uniqueId}`,
      placeholder: "Meaning of root word",
      qa: "root-word-meaning",
      maxLength: INPUT_MAX_LENGTH,
    },
  },
  {
    key: "suffix",
    label: "Suffix",
    id: (uniqueId: string) => `suffix-${uniqueId}`,
    placeholder: "None",
    qa: "suffix",
    maxLength: INPUT_MAX_LENGTH,
    meaning: {
      key: "suffix_meaning",
      label: "Suffix meaning",
      id: (uniqueId: string) => `suffix-meaning-${uniqueId}`,
      placeholder: "Meaning of suffix",
      qa: "suffix-meaning",
      maxLength: INPUT_MAX_LENGTH,
    },
  },
];

export const WORD_DEFINITION_AND_EXAMPLES_FIELDS: WordDefinitionFieldProps[] = [
  {
    key: "definition",
    label: "My definition",
    id: (uniqueId: string) => `definition-${uniqueId}`,
    placeholder: "Write a definition in your own words",
    qa: "definition",
    maxLength: MAX_LENGTH,
  },
  {
    key: "related_words",
    label: "Related words",
    id: (uniqueId: string) => `related-words-${uniqueId}`,
    placeholder: "Words with the same prefix, root, or suffix",
    qa: "related-words",
    maxLength: MAX_LENGTH,
  },
  {
    key: "sentence",
    label: "Use it in a sentence",
    id: (uniqueId: string) => `sentence-${uniqueId}`,
    placeholder: "Write a sentence using the word",
    qa: "sentence",
    maxLength: MAX_LENGTH,
  },
];
